export type ServerLayout={order:string[];folders:{id:string;name:string;members:string[]}[]};
// A folder is drawn where its top-most server sits in the order. When a server joins a folder it is therefore moved
// right behind the folder's servers, so the folder stays in place and the servers above it do not slide below it.
function placeBehind(order:string[],id:string,members:string[]):string[]{
 const others=members.filter(m=>m!==id).map(m=>order.indexOf(m)).filter(i=>i>=0),at=order.indexOf(id);
 if(!others.length||at<0)return order;
 // Already placed within the folder's range (e.g. dropped between two of its servers): keep that exact spot.
 if(at>=Math.min(...others)&&at<=Math.max(...others)+1)return order;
 const rest=order.filter(x=>x!==id),last=Math.max(...members.filter(m=>m!==id).map(m=>rest.indexOf(m)));
 return [...rest.slice(0,last+1),id,...rest.slice(last+1)];
}
export function groupServers(layout:ServerLayout,source:string,target:string,folderId:string|undefined,newId:string,name:string):ServerLayout{
 if(source===target||!layout.order.includes(source)||!layout.order.includes(target))return layout;
 const existing=folderId&&layout.folders.some(f=>f.id===folderId)?folderId:undefined;
 const folders=layout.folders.map(f=>({...f,members:f.members.filter(id=>id!==source&&(existing||id!==target))}));
 let members:string[];
 if(existing){const f=folders.find(f=>f.id===existing)!;f.members=[...new Set([...f.members,source])];members=f.members;}
 else{members=[target,source];folders.push({id:newId,name,members});}
 return {...layout,order:placeBehind(layout.order,source,members),folders:folders.filter(f=>f.members.length)};
}
// Moves a server out of any folder; folders left empty disappear.
export function removeFromFolder(layout:ServerLayout,id:string):ServerLayout{
 return {...layout,folders:layout.folders.map(f=>({...f,members:f.members.filter(x=>x!==id)})).filter(f=>f.members.length)};
}
// Puts a server into an existing folder (and nowhere else).
export function addToFolder(layout:ServerLayout,id:string,folderId:string):ServerLayout{
 const folder=layout.folders.find(f=>f.id===folderId);if(!folder)return layout;
 return {...layout,order:placeBehind(layout.order,id,folder.members),folders:layout.folders.map(f=>({...f,members:f.id===folderId?[...new Set([...f.members.filter(x=>x!==id),id])]:f.members.filter(x=>x!==id)})).filter(f=>f.members.length)};
}
